import MarketingOptIn from './marketing-opt-in'

export default MarketingOptIn
